import last from 'lodash/last';
export const _last = last;
